module.exports = __webpack_public_path__ + "img/mall.3f9424a0.png";